import Vue from 'vue'
import _ from 'lodash'
import common from '@/utils/common'

const set = (state, path, val) => {
  let currentPath = null
  _.chain(path)
    .split('.')
    .forEach((path, index, list) => {
      const current = currentPath == null ? state : _.get(state, currentPath)
      if ((list.length - 1) === index) {
        Vue.set(current, path, val)
      } else if (!_.has(current, path)) {
        Vue.set(current, path, {})
      }
      currentPath = currentPath == null ? path : `${currentPath}.${path}`
    })
    .value()
}

export default {
  namespaced: true,
  getters: {
    sortCondition: (state) => (path) => {
      const defaultSort = { prop: null, order: null }
      if (path == null || path === '') {
        return defaultSort
      }
      return _.get(state, `${common.getUserUniqueKey()}.sortCondition.${path}`, defaultSort)
    },
    paginationSize: (state) => (path) => {
      if (path == null || path === '') {
        return 10
      }
      return _.get(state, `${common.getUserUniqueKey()}.paginationSize.${path}`, 10)
    }
  },
  actions: {
    setSortCondition ({ commit }, { path, sort }) {
      commit('setSortCondition', { path, sort })
    },
    setPaginationSize ({ commit }, { path, size }) {
      commit('setPaginationSize', { path, size })
    }
  },
  mutations: {
    setSortCondition (state, { path, sort }) {
      if (path == null || path === '') {
        return
      }
      set(state, `${common.getUserUniqueKey()}.sortCondition.${path}`, sort)
    },
    setPaginationSize (state, { path, size }) {
      if (path == null || path === '') {
        return
      }
      set(state, `${common.getUserUniqueKey()}.paginationSize.${path}`, size)
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/localStorage.js